import { render, staticRenderFns } from "./UnidentifiedPaymentsTable.vue?vue&type=template&id=780712c0&scoped=true"
import script from "./UnidentifiedPaymentsTable.vue?vue&type=script&lang=js"
export * from "./UnidentifiedPaymentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780712c0",
  null
  
)

export default component.exports